import { GrayColors } from "@smartsuite/types";
// TODO: localize labels
export const colors = [
    {
        label: "Default",
        value: "rgb(255,255,255)",
        class: "default",
    },
    {
        label: "Gray",
        value: GrayColors["G-1-5"],
        class: "gray",
    },
    {
        label: "Brown",
        value: "rgb(233,229,227)",
        class: "brown",
    },
    {
        label: "Orange",
        value: "rgba(255, 146, 16, 0.15)",
        class: "orange",
    },
    {
        label: "Yellow",
        value: "rgba(255, 185, 56, 0.15)",
        class: "yellow",
    },
    {
        label: "Green",
        value: "rgba(62, 172, 64, 0.15)",
        class: "green",
    },
    {
        label: "Blue",
        value: "rgba(58, 134, 255, 0.15)",
        class: "blue",
    },
    {
        label: "Purple",
        value: "rgba(136, 60, 208, 0.15)",
        class: "purple",
    },
    {
        label: "Pink",
        value: "rgba(236, 80, 110, 0.15)",
        class: "pink",
    },
    {
        label: "Red",
        value: "rgba(255, 87, 87, 0.15)",
        class: "red",
    },
];
